
import APIClient from './APIClient'

class CDivisionsAPI {

  async list() {
    const res = await APIClient.GET('/divisions')
    return res
  }

  async get(id) {
    const res = await APIClient.GET('/divisions/'+id)
    return res
  }

  async create({name}) {
    return await APIClient.POST('/divisions', { name })
  }

  async update(id, {name}) {
    const res = await APIClient.POST('/divisions/'+id, { name })
    return res
  }

  async delete(id) {
    const res = await APIClient.DELETE('/divisions/'+id)
    return res
  }
}

const DivisionsAPI = new CDivisionsAPI()

export default DivisionsAPI



// WEBPACK FOOTER //
// ./src/api/DivisionsAPI.js